export const RETRIEVING_LEADERBOARD = 'Retrieving Leaderboard';
export const DOWNLOADING_LEADERBOARD_EXCEL = 'Downloading Leaderboard Excel';
